import React, { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { Context } from '../Store'

import { getNextStep } from './StepValidation'
import { redirectToAuthWithFrom } from '../utils/UserContext'

const DiscoverStep = ({ history, match }) => {
  const [state, dispatch, loadBooking] = useContext(Context)

  useEffect(() => {
    loadBooking({ id: match.params.bookingId }).then(async ({ booking, error }) => {
      if (booking && !error) {
        const step = await getNextStep(booking)
        history.replace(`/bookings/${booking.id}/${step}`)
      } else if (error === 401) {
        redirectToAuthWithFrom()
      }
    })
  }, [])

  let html = <div className="flex justify-center content-center w-full">loading booking</div>
  if (state.booking) {
    html = <div className="flex justify-center content-center w-full">looking for the right step...</div>
  }

  return html
}

export default withRouter(DiscoverStep)
